module.exports = {
      id: "double-arrow-usage",
      viewBox: "0 0 21.133 19.508",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#double-arrow",
      toString: function () {
        return this.url;
      }
    }